export const formTypes = {
    Hexagon: 'hexagon-form',
    Ellipse: 'ellipse-form',
    None: 'none-form',
    ArrowRight: 'arrow-right-form',
    ArrowLeft: 'arrow-left-form',
    StopSign: 'stop-sign-form',
    RotatedSquare: 'rotated-square-form',
    Triangle: 'triangle-form',
    Oval: 'oval-form',
};
